import React from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import FlexContainer from "connectui/component/layout/FlexContainer";
import TypingDots from "./TypingDots";
import {buildStyles} from "connectui/component/buildStyles";

const useMessageContentTypingStyles = (theme) =>
  buildStyles({
    container: {
      backgroundColor: theme.colors.primary600,
      borderStartStartRadius: `${theme.radius.lg}px`,
      borderStartEndRadius: 0,
      borderEndStartRadius: `${theme.radius.lg}px`,
      borderEndEndRadius: `${theme.radius.lg}px`,
      boxShadow: theme.shadows.sm,
      padding: theme.spacing(2, 3.5),
      gap: theme.spacing(2),
    },
  });

const MessageContentTypingIndicator = () => {
  const {theme} = useTheme();
  const classes = useMessageContentTypingStyles(theme);

  return (
    <FlexContainer
      flexDirection="row"
      alignItems="center"
      className={classes.container}
    >
      <TypingDots />
    </FlexContainer>
  );
};

export default MessageContentTypingIndicator;
